import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Anchor, Bell, LogOut, Ship, Wrench, LayoutGrid, ShieldCheck, Wallet as WalletIcon } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import SupportButton from "@/components/SupportButton";

export default function Navbar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const isPro = user?.role === "professional";
  const isOwner = user?.role === "owner";
  const isAdmin = user?.role === "admin";

  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-white/70 border-b border-[#0B1D3A]/10">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5" data-testid="nav-logo">
          <div className="w-9 h-9 rounded-full bg-[#0B1D3A] text-[#EFE9E1] flex items-center justify-center">
            <Anchor size={18} strokeWidth={2.2} />
          </div>
          <div className="font-serif text-2xl leading-none">Marina<span className="hub-coral italic">Hub</span></div>
        </Link>
        <nav className="hidden md:flex items-center gap-8 font-display text-sm">
          <Link to="/como-funciona" className="text-[#0B1D3A]/70 hover:text-[#0B1D3A]" data-testid="nav-como-funciona">Cómo funciona</Link>
          <Link to="/puertos" className="text-[#0B1D3A]/70 hover:text-[#0B1D3A]" data-testid="nav-puertos">Puertos</Link>
          <Link to="/servicios" className="text-[#0B1D3A]/70 hover:text-[#0B1D3A]" data-testid="nav-servicios">Servicios</Link>
        </nav>
        <div className="flex items-center gap-2">
          {!user && (
            <>
              <Button variant="ghost" className="rounded-full font-display" onClick={() => nav("/login")} data-testid="nav-login-btn">Entrar</Button>
              <Button className="hub-btn-primary" onClick={() => nav("/register")} data-testid="nav-register-btn">Empezar</Button>
            </>
          )}
          {user && (
            <>
              {(isOwner || isPro) && <SupportButton />}
              {isOwner && (
                <>
                  <Button variant="ghost" className="rounded-full font-display gap-2" onClick={() => nav("/owner")} data-testid="nav-owner-dash">
                    <Ship size={16}/> Panel
                  </Button>
                  <Button variant="ghost" className="rounded-full font-display gap-2" onClick={() => nav("/boats")} data-testid="nav-boats">
                    <Anchor size={16}/> Mis barcos
                  </Button>
                </>
              )}
              {isPro && (
                <>
                  <Button variant="ghost" className="rounded-full font-display gap-2" onClick={() => nav("/pro")} data-testid="nav-pro-dash">
                    <Wrench size={16}/> Panel
                  </Button>
                  <Button variant="ghost" className="rounded-full font-display gap-2" onClick={() => nav("/wallet")} data-testid="nav-wallet">
                    <WalletIcon size={16}/> Cartera
                  </Button>
                  <Button variant="ghost" className="rounded-full font-display gap-2" onClick={() => nav("/pro/kyc")} data-testid="nav-kyc">
                    <ShieldCheck size={16}/> KYC
                  </Button>
                  <Button variant="ghost" className="rounded-full font-display gap-2" onClick={() => nav("/pro/connect")} data-testid="nav-connect">
                    <LayoutGrid size={16}/> Cobros
                  </Button>
                </>
              )}
              {isAdmin && (
                <Button variant="ghost" className="rounded-full font-display gap-2" onClick={() => nav("/admin")} data-testid="nav-admin-panel">
                  <ShieldCheck size={16}/> Panel Admin
                </Button>
              )}
              <Button variant="ghost" size="icon" className="rounded-full" onClick={logout} data-testid="nav-logout-btn">
                <LogOut size={16}/>
              </Button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
